// What the charts model is built from, ported from the coffee block's calcChartsModelProps.
//
// A view mode with no chart to draw, or a question whose data has not arrived, yields the empty
// kind. The two tag-shaped modes resolve their key list through the family's own lib: sentiments
// name the question's sentiments, tags name the tags of the codebook the config points at.
//
// A family whose modes go beyond those answers through `calcExtraProps`; see cn/lib/props for the
// conversation one.

const TAG_VIEW_MODES = ['sentiments', 'tags']

export const calcChartsModelProps = ({
  answer,
  viewMode,
  config,
  questionKey,
  type,
  lib,
  chartViewModes = [],
  calcExtraProps
} = {}) => {
  const props = { viewMode, answer, config, kind: 'empty' }

  if ('loading' === answer || !chartViewModes.includes(viewMode)) return props

  if (TAG_VIEW_MODES.includes(viewMode)) {
    const key = lib.getKey(questionKey, config)

    return {
      ...props,
      kind: 'tags',
      keys:
        ('sentiments' === viewMode && lib.getQuestionSentiments(key, type)) ||
        ('tags' === viewMode && lib.getQuestionTags(key, type, config?.codebook)) ||
        [],
      codebook: config?.codebook || null
    }
  }

  return calcExtraProps?.({ answer, viewMode, config, questionKey, type, lib }) || props
}
